(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-banner-with-carousel"] && !Shopify.designMode) return;
  try {
    
  class PivotCarruBanner extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('pivot-carousel');
      if (this.slider.inited) this.init();
      else this.slider.addEventListener('init', () => this.init());
    }
    init() {
      console.log('Haciendo el init');
      const splide = this.slider.splide;
      const max = Math.ceil(splide.Components.Elements.slides.length / this.slider.desktopColumns);
      const $range = this.querySelector('.pivot-carrubanner-progress');
      $range.type = 'range';
      $range.min = 0;
      $range.value = 0;
      $range.step = 0.1;
      this.appendChild($range);
      $range.addEventListener('input', (e) => {
        const index = Math.round(Number(e.target.value));
        console.log(index);
        splide.Components.Controller.go(index);
      });
      splide.on('mounted resize', () => {
        const totalSlides = splide.Components.Elements.slides.length;
        const perPage = innerWidth > 750 ? this.slider.desktopColumns : this.slider.mobileColumns;
        const totalScrollWidth = (perPage * 100) / totalSlides;
        $range.max = splide.Components.Controller.getEnd();
        if (totalScrollWidth >= 100) $range.style.setProperty('visibility', 'hidden');
        else $range.style.setProperty('visibility', 'visible');
        $range.style.setProperty('--scroll-width', `${totalScrollWidth}%`);
      });
      splide.on('mounted move dragging scroll', () => {
        $range.value = splide.Components.Controller.getIndex();
      });
    }
  }
  if (!customElements.get('pivot-carrubanner')) {
    customElements.define('pivot-carrubanner', PivotCarruBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-form-builder"] && !Shopify.designMode) return;
  try {
    
  class PVTNewsletter extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.isConnected) return;
      this.$inputs = this.querySelectorAll('.pvt-tag-field');
      this.$form = this.querySelector('form');
      this.$tags = this.querySelector('input[name="contact[tags]"]');
      this.$form.addEventListener('change', (e) => {
        e.preventDefault();
        const form = new FormData(this.$form);
        const tags = Object.keys(Object.fromEntries(form)).reduce((acc, key) => {
          const item = form.getAll(key);
          if (!key.startsWith('tags__')) return acc;
          const inp = this.$form.querySelector(`[name="${key}"]`);
        
          const formatter = (val) => {
            if (inp?.dataset.type === 'rut') {
              return formatRut(val);
            }
            if (inp?.dataset.type === 'phone') {
              return val.startsWith(inp.dataset.prefix) ? val : `${inp.dataset.prefix}${val}`;
            }
            return val.trim().replaceAll(',', '|');
          }

          acc.push(
            `${key.replace('tags__', '')}:${item
              .map((itm) => formatter(itm))
              .join('_')}`
          );
          return acc;
        }, []);
        this.$tags.value = tags.join(',');
      });
    }
  }
  if (!customElements.get('pvt-newsletter')) {
    customElements.define('pvt-newsletter', PVTNewsletter);
  }

  function cleanRut(rut) {
    return typeof rut === 'string' ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase() : '';
  }

  function validateRut(rut) {
    if (typeof rut !== 'string') {
      return false;
    }

    // if it starts with 0 we return false
    // so a rut like 00000000-0 will not pass
    if (/^0+/.test(rut)) {
      return false;
    }

    if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(rut)) {
      return false;
    }

    rut = cleanRut(rut);

    let t = parseInt(rut.slice(0, -1), 10);
    let m = 0;
    let s = 1;

    while (t > 0) {
      s = (s + (t % 10) * (9 - (m++ % 6))) % 11;
      t = Math.floor(t / 10);
    }

    const v = s > 0 ? '' + (s - 1) : 'K';
    return v === rut.slice(-1);
  }

  function formatRut(
    rut,
    options = {
      dots: true,
    }
  ) {
    rut = cleanRut(rut);

    let result;
    if (options.dots) {
      result = rut.slice(-4, -1) + '-' + rut.substr(rut.length - 1);
      for (let i = 4; i < rut.length; i += 3) {
        result = rut.slice(-3 - i, -i) + '.' + result;
      }
    } else {
      result = rut.slice(0, -1) + '-' + rut.substr(rut.length - 1);
    }

    return result;
  }

  function getCheckDigit(input) {
    const rut = Array.from(cleanRut(input), Number);

    if (rut.length === 0 || rut.includes(NaN)) {
      throw new Error(`"${input}" as RUT is invalid`);
    }

    const modulus = 11;
    const initialValue = 0;
    const sumResult = rut
      .reverse()
      .reduce((accumulator, currentValue, index) => accumulator + currentValue * ((index % 6) + 2), initialValue);

    const checkDigit = modulus - (sumResult % modulus);

    if (checkDigit === 10) {
      return 'K';
    } else if (checkDigit === 11) {
      return '0';
    } else {
      return checkDigit.toString();
    }
  }

  class PivotRutInput extends HTMLElement {
    constructor() {
      super();
      this.$input = this.querySelector('input');
      const validator = () => {
        const isValid = validateRut(this.$input.value);
        this.$input.classList.add('is-invalid', isValid);
        if (isValid) this.$input.removeAttribute('pattern');
        else this.$input.setAttribute('pattern', ['!/^0*(d{1,3}(.?d{3})*)-?([dkK])$/']);
        this.$input.ariaInvalid = !isValid;
      };
      this.addEventListener('keyup', validator);
      this.addEventListener('blur', (e) => {
        this.$input.value = formatRut(this.$input.value);
      });
    }
  }
  if (!customElements.get('pivot-rut-input')) {
    customElements.define('pivot-rut-input', PivotRutInput);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-store-attributes"] && !Shopify.designMode) return;
  try {
    
  class PivotStoreAttributes extends HTMLElement {
    constructor() {
      super();
      this.dkColumns = Number(this.getAttribute('dk-columns') || 1);
      this.mbColumns = Number(this.getAttribute('mb-columns') || 1);
      this.dkCarousel = this.getAttribute('dk-carousel') === 'true';
      this.mbCarousel = this.getAttribute('mb-carousel') === 'true';
      this.dkArrows = this.getAttribute('dk-arrows') === 'true';
      this.mbArrows = this.getAttribute('mb-arrows') === 'true';
      this.dkDots = this.getAttribute('dk-dots') === 'true';
      this.mbDots = this.getAttribute('mb-dots') === 'true';
      this.enableDivider = this.getAttribute('enable-divider') === 'true';
      this.paginationColorScheme = this.dataset.paginationColorScheme;
      this.dkAutoplay = this.getAttribute('dk-autoplay') === 'true';
      this.mbAutoplay = this.getAttribute('mb-autoplay') === 'true';
      this.dkAutoplayDuration = Number(this.getAttribute('dk-autoplay-duration') || 3);
      this.mbAutoplayDuration = Number(this.getAttribute('mb-autoplay-duration') || 3);
      this.dkLoop = this.getAttribute('dk-loop') === 'true';
      this.mbLoop = this.getAttribute('mb-loop') === 'true';
    }
    async connectedCallback() {
      if (!this.isConnected) return;
      await import('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js');
      const config = {
        type: this.dkLoop ? 'loop': 'slide',
        perPage: this.dkColumns,
        gap: this.enableDivider ? '2rem' : '4rem',
        destroy: !this.dkCarousel,
        arrows: this.dkArrows,
        pagination: this.dkDots,
        autoplay: this.dkAutoplay,
        interval: this.dkAutoplayDuration * 1000,
        breakpoints: {
          750: {
            type: this.mbLoop ? 'loop': 'slide',
            perPage: this.mbColumns,
            gap: this.enableDivider ? '1rem' : '2rem',
            destroy: !this.mbCarousel,
            arrows: this.mbArrows,
            pagination: this.mbDots,
            autoplay: this.mbAutoplay,
            interval: this.mbAutoplayDuration * 1000
          },
        },
      };

      console.log('Config', config);

      this.splide = new Splide(this.querySelector('.splide'), config);
      this.splide.on('mounted', () => {
        const pagination = this.querySelector('.splide__pagination');
        pagination.classList.add(`color-${this.paginationColorScheme}`);
      });
      this.splide.mount();
    }
  }
  if (!customElements.get('pivot-store-attributes')) {
    customElements.define('pivot-store-attributes', PivotStoreAttributes);
  }

  } catch(e) { console.error(e); }
})();
})();
